import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentChannelFulfilled() {
  return (
    <FulfillmentQueue
      title="Channel Fulfilled"
      statusFilter="channel_fulfilled"
      emptyMessage="No channel-fulfilled orders"
    />
  );
}
